export const RUB = '₽';
